import { useEffect, useRef, useState, useCallback } from "react";

const heroImages = [
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/9ab579f2-7c04-4fc5-9ad9-40c8758a68bb_SnapShot5---.jpg?v=dac08913f0715b9b87f27ecc80488ff2",
    alt: "トラックボーイズ ショット1",
    rotate: -6,
    color: "#FF0F0F",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/d8f2dacd-6a10-48b6-830e-63a9e2357d5a_SnapShot.jpg?v=4a12ecec7196d675c2466e538db7937d",
    alt: "トラックボーイズ ショット2",
    rotate: 4,
    color: "#0066FF",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/71ca080e-6920-42ac-90f2-0b6637bd9514_301437.jpg?v=808ac079761723fcf52ae30ead19ac7c",
    alt: "トラックボーイズ ショット3",
    rotate: -3,
    color: "#00B050",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/fc2df659-5f23-4ace-9431-eeba409e0895_069A0027.jpg?v=d4e47b807693cd37bedab3b2cb1807ba",
    alt: "トラックボーイズ ショット4",
    rotate: 7,
    color: "#FFD700",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/e35d9870-144c-49c8-ba35-ec4831eb7229_069A0561.jpg?v=b0c5efea555fcde0a942ad9bd1bdf972",
    alt: "トラックボーイズ ショット5",
    rotate: -5,
    color: "#FF0F0F",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/1be619db-77ef-4632-a046-4d9df9a0653b_-2025-02-12-123325.png?v=061cbbdd41d8293519f17ababbd104ab",
    alt: "トラックボーイズ ショット6",
    rotate: 3,
    color: "#0066FF",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/70eef3fa-d53d-43af-a16f-2dfe8199f3f2_-2026-04-01-172047.png?v=4df99c9f222c932d3e6cfd3f3e438d6a",
    alt: "トラックボーイズ ショット7",
    rotate: -8,
    color: "#00B050",
  },
  {
    src: "https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/ec4e5844-5fed-4aae-8d0c-8dc00eb9ff74_-2026-04-01-183659.png?v=7454c127ff9f85a20930491fe3c39083",
    alt: "トラックボーイズ ショット8",
    rotate: 5,
    color: "#FFD700",
  },
];

const playlists = [
  {
    title: "超初心者向けシリーズ",
    tag: "#初心者",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/a83e238d6147cdf763df639485f63c8a.png",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-yCdzSilUy6X_sh4aIggpi&si=l_f_adWa8RwqpURz",
  },
  {
    title: "長距離シリーズ",
    tag: "#長距離",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/f3c509b7034404a62606452e2d4f4480.png",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-HzwyKcRxQx02cb4WyDybI&si=FZVMkWH-ajv_P9PE",
  },
  {
    title: "あるある歌シリーズ",
    tag: "#あるある",
    tagColor: "bg-[#0066FF]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/df1ccd559fae0a2c23838d46c963b06e.png",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-hUj-BtE0HP_6LRTXJOqUT&si=8pE62uHAkuoiESAx",
  },
  {
    title: "転職シリーズ",
    tag: "#転職",
    tagColor: "bg-[#00B050]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/d059910994dc70784e9f629f6f840303.png",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_3UOKczZgYgB_0wl0QuKyo&si=kTvvwkRg7GvZf9h3",
  },
  {
    title: "社内イベント",
    tag: "#イベント",
    tagColor: "bg-[#00B050]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/221f4c8489145fe08ea9796641079203.jpeg",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg-hsU9hmVnFq7xslTWlh7bz&si=cVg9HquJe5gXFQ-_",
  },
  {
    title: "さくやくんシリーズ",
    tag: "#恋愛",
    tagColor: "bg-[#FFD700]",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/c378ba74d56d58e2ba6912831d54dd46.jpeg",
    url: "https://youtube.com/playlist?list=PLEvleHvb7Eg_SkqbycvPtS0CpDNbxuNl5&si=p_qyX366EaO_QyNo",
  },
];

function PlaylistSlider() {
  const [current, setCurrent] = useState(0);
  const total = playlists.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const getVisible = () => {
    const indices = [];
    for (let i = -1; i <= 1; i++) {
      indices.push((current + i + total) % total);
    }
    return indices;
  };

  const visible = getVisible();

  return (
    <div className="w-full mb-6">
      <p className="text-xs font-black text-gray-400 tracking-widest mb-2 text-center lg:text-left">
        ▶ 再生リスト
      </p>
      <div className="relative flex items-center gap-2">
        <button
          onClick={prev}
          className="shrink-0 w-7 h-7 flex items-center justify-center bg-black text-white rounded-full border-2 border-black cursor-pointer hover:bg-[#FF0F0F] transition-colors z-10"
        >
          <i className="ri-arrow-left-s-line text-base" />
        </button>

        <div className="flex-1 overflow-hidden">
          <div className="flex gap-2 justify-center">
            {visible.map((idx, pos) => {
              const item = playlists[idx];
              const isCenter = pos === 1;
              return (
                <a
                  key={idx}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`shrink-0 rounded-xl border-2 border-black overflow-hidden cursor-pointer transition-all duration-300 ${
                    isCenter
                      ? "w-28 opacity-100 scale-100"
                      : "w-20 opacity-50 scale-95"
                  }`}
                  style={{ boxShadow: isCenter ? "3px 3px 0px #000" : "none" }}
                >
                  <div className="relative" style={{ height: isCenter ? "72px" : "56px" }}>
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className={`absolute top-1 left-1 ${item.tagColor} text-white font-black text-[9px] px-1.5 py-0.5 rounded-full border border-black`}>
                      {item.tag}
                    </div>
                    {isCenter && (
                      <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 hover:opacity-100 transition-opacity">
                        <i className="ri-play-circle-fill text-white text-2xl" />
                      </div>
                    )}
                  </div>
                  {isCenter && (
                    <div className="bg-white px-1.5 py-1">
                      <p className="font-black text-[10px] text-black leading-tight line-clamp-1">{item.title}</p>
                    </div>
                  )}
                </a>
              );
            })}
          </div>
        </div>

        <button
          onClick={next}
          className="shrink-0 w-7 h-7 flex items-center justify-center bg-black text-white rounded-full border-2 border-black cursor-pointer hover:bg-[#FF0F0F] transition-colors z-10"
        >
          <i className="ri-arrow-right-s-line text-base" />
        </button>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center lg:justify-start gap-1 mt-2">
        {playlists.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className="cursor-pointer rounded-full border border-black transition-all duration-200"
            style={{
              width: i === current ? "16px" : "6px",
              height: "6px",
              background: i === current ? "#FF0F0F" : "#ccc",
            }}
          />
        ))}
      </div>
    </div>
  );
}

// ---- 3D Card Stack ----
const VISIBLE_CARDS = 4;

interface CardStackProps {
  images: typeof heroImages;
}

function CardStack({ images }: CardStackProps) {
  const [topIndex, setTopIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [flyOut, setFlyOut] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const advance = useCallback(() => {
    if (animating) return;
    setAnimating(true);
    setFlyOut(true);
    setTimeout(() => {
      setTopIndex((prev) => (prev + 1) % images.length);
      setFlyOut(false);
      setTimeout(() => setAnimating(false), 50);
    }, 420);
  }, [animating, images.length]);

  useEffect(() => {
    timerRef.current = setInterval(advance, 2800);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [advance]);

  const handleClick = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    advance();
    timerRef.current = setInterval(advance, 2800);
  };

  // Build the stack: show VISIBLE_CARDS cards, bottom → top
  const stackIndices: number[] = [];
  for (let i = VISIBLE_CARDS - 1; i >= 0; i--) {
    stackIndices.push((topIndex + i) % images.length);
  }
  // stackIndices[0] = bottom card, stackIndices[last] = top card

  return (
    <div
      className="relative cursor-pointer select-none"
      style={{ width: "100%", height: "320px" }}
      onClick={handleClick}
      title="クリックで次の写真へ"
    >
      {/* Perspective wrapper */}
      <div
        className="absolute inset-0"
        style={{ perspective: "900px", perspectiveOrigin: "50% 40%" }}
      >
        {stackIndices.map((imgIdx, stackPos) => {
          const isTop = stackPos === stackIndices.length - 1;
          const depth = stackIndices.length - 1 - stackPos; // 0 = top, higher = deeper

          // Each card gets a fixed tilt from the image data, offset by depth
          const baseRotate = images[imgIdx].rotate;
          const borderColor = images[imgIdx].color;

          // Stacking offsets: deeper cards shift slightly
          const offsetX = depth * 3;
          const offsetY = depth * -5;
          const scale = 1 - depth * 0.04;
          const rotateZ = baseRotate + depth * 1.5;
          const rotateY = depth * -3;

          // Top card fly-out animation
          const flyStyle: React.CSSProperties = isTop && flyOut
            ? {
                transform: `
                  translateX(${offsetX + 60}px)
                  translateY(${offsetY - 80}px)
                  scale(${scale * 0.85})
                  rotateZ(${rotateZ + 25}deg)
                  rotateY(${rotateY + 30}deg)
                `,
                opacity: 0,
                transition: "transform 0.42s cubic-bezier(0.4,0,0.2,1), opacity 0.42s ease",
              }
            : {
                transform: `
                  translateX(${offsetX}px)
                  translateY(${offsetY}px)
                  scale(${scale})
                  rotateZ(${rotateZ}deg)
                  rotateY(${rotateY}deg)
                `,
                opacity: 1,
                transition: isTop
                  ? "transform 0.42s cubic-bezier(0.4,0,0.2,1), opacity 0.42s ease"
                  : "transform 0.35s cubic-bezier(0.4,0,0.2,1)",
              };

          return (
            <div
              key={imgIdx}
              className="absolute"
              style={{
                width: "100%",
                height: "100%",
                transformStyle: "preserve-3d",
                zIndex: stackPos + 1,
                ...flyStyle,
              }}
            >
              {/* Card frame */}
              <div
                className="w-full h-full rounded-2xl overflow-hidden border-4"
                style={{
                  borderColor,
                  boxShadow: isTop
                    ? `6px 8px 0px #000, 0 16px 40px rgba(0,0,0,0.28)`
                    : `3px 4px 0px #000, 0 8px 20px rgba(0,0,0,${0.12 + depth * 0.04})`,
                  background: "#fff",
                }}
              >
                <img
                  src={images[imgIdx].src}
                  alt={images[imgIdx].alt}
                  className="w-full h-full object-cover object-top"
                  draggable={false}
                />
                {/* Gloss overlay on top card */}
                {isTop && (
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(255,255,255,0.18) 0%, transparent 60%)",
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Tap hint */}
      <div
        className="absolute bottom-2 right-2 z-50 bg-black/60 text-white font-black text-[10px] px-2 py-1 rounded-full border border-white/30 pointer-events-none"
        style={{ backdropFilter: "blur(4px)" }}
      >
        タップで次へ ▶
      </div>
    </div>
  );
}

// ---- Scroll animation hook ----
function useScrollAnim() {
  useEffect(() => {
    const els = document.querySelectorAll(".anim-fade-up, .anim-fade-left, .anim-fade-right, .anim-scale-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function HeroSection() {
  useScrollAnim();
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
          }
        });
      },
      { threshold: 0.1 }
    );
    if (textRef.current) observer.observe(textRef.current);
    return () => observer.disconnect();
  }, []);

  const catchCopyLine1 = [
    { text: "助手席", color: "text-[#FF0F0F]", rotate: "-rotate-2" },
    { text: "に乗ってる", color: "text-black" },
    { text: "仲良し♪", color: "text-[#0066FF]", rotate: "rotate-2" },
  ];
  const catchCopyLine2 = [
    { text: "そんな", color: "text-black" },
    { text: "動画", color: "text-[#00B050]", rotate: "-rotate-1" },
    { text: "を目指してます♪", color: "text-black" },
  ];

  return (
    <section className="relative min-h-screen bg-white overflow-hidden flex items-center">
      {/* Decorative shapes */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/790e26b1-4903-42fd-8507-ba7d8d417552_unnamed.png?v=52293944748ae935fc8b05774a7d9b89"
          alt=""
          className="absolute bottom-10 left-4 w-28 md:w-36 opacity-90 animate-float"
          style={{ "--rot": "-6deg" } as React.CSSProperties}
        />
        <img
          src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/9e0c9e3b-ad27-410f-af51-1809765a0cf9_unnamed.png?v=c9dadf5944fc8281a85862295cc7bf89"
          alt=""
          className="absolute top-16 right-4 w-24 md:w-32 opacity-80 animate-float-slow"
          style={{ "--rot": "6deg", animationDelay: "1s" } as React.CSSProperties}
        />
        <div className="absolute top-16 left-8 w-24 h-24 rounded-full bg-[#0066FF] opacity-20 animate-pulse-scale" />
        <div className="absolute top-40 left-40 w-12 h-12 rounded-full bg-[#0066FF] opacity-30 animate-float" style={{ animationDelay: "0.5s" }} />
        <div className="absolute bottom-32 left-16 w-36 h-36 rounded-full bg-[#0066FF] opacity-15 animate-spin-slow" />
        <div className="absolute top-12 right-20 w-20 h-20 rounded-full bg-[#FF0F0F] opacity-25 animate-pulse-scale" style={{ animationDelay: "0.8s" }} />
        <div className="absolute top-60 right-8 w-8 h-8 rounded-full bg-[#FF0F0F] opacity-40 animate-float" style={{ animationDelay: "1.2s" }} />
        <div className="absolute bottom-20 right-40 w-28 h-28 rounded-full bg-[#FF0F0F] opacity-15 animate-spin-slow-rev" />
        <div className="absolute top-28 left-1/2 w-16 h-16 rotate-45 bg-[#00B050] opacity-20 animate-wiggle" />
        <div className="absolute bottom-40 left-1/3 w-10 h-10 rotate-12 bg-[#00B050] opacity-30 animate-float" style={{ animationDelay: "0.3s" }} />
        <div className="absolute top-1/2 right-32 w-20 h-20 rounded-full bg-[#00B050] opacity-20 animate-pulse-scale" style={{ animationDelay: "1.5s" }} />
        <div className="absolute top-8 left-1/3 w-14 h-14 rounded-full bg-[#FFD700] opacity-30 animate-float-slow" style={{ animationDelay: "0.7s" }} />
        <div className="absolute bottom-16 right-24 w-18 h-18 rounded-full bg-[#FFD700] opacity-25 animate-spin-slow" style={{ animationDelay: "2s" }} />
        <svg className="absolute bottom-0 left-0 w-full opacity-10" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,60 C240,100 480,20 720,60 C960,100 1200,20 1440,60 L1440,120 L0,120 Z" fill="#0066FF"/>
        </svg>
        <svg className="absolute top-0 right-0 w-64 opacity-10 animate-spin-slow" viewBox="0 0 200 200">
          <circle cx="100" cy="100" r="80" fill="none" stroke="#FF0F0F" strokeWidth="8" strokeDasharray="20 10"/>
        </svg>
        <svg className="absolute bottom-24 left-0 w-48 opacity-10 animate-spin-slow-rev" viewBox="0 0 200 200">
          <circle cx="100" cy="100" r="70" fill="none" stroke="#00B050" strokeWidth="8" strokeDasharray="15 10"/>
        </svg>
        <div className="absolute top-0 right-0 w-80 h-80 opacity-5"
          style={{
            backgroundImage: "radial-gradient(circle, #000 1.5px, transparent 1.5px)",
            backgroundSize: "24px 24px"
          }}
        />
        <div className="absolute bottom-0 left-0 w-80 h-80 opacity-5"
          style={{
            backgroundImage: "radial-gradient(circle, #000 1.5px, transparent 1.5px)",
            backgroundSize: "24px 24px"
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16 flex flex-col lg:flex-row items-center gap-10 w-full">
        {/* 3D Card Stack */}
        <div className="flex-shrink-0 w-full lg:w-[480px] anim-fade-left">
          <div className="relative px-6 lg:px-4 py-8">
            <CardStack images={heroImages} />
          </div>
        </div>

        {/* Text content */}
        <div ref={textRef} className="flex-1 text-center lg:text-left">
          <div className="anim-fade-up anim-delay-100">
            <div className="inline-block bg-[#FFD700] text-black font-black text-sm px-4 py-1 rounded-full mb-4 tracking-widest animate-pulse-scale">
              🚛 TRUCK BOYS OFFICIAL SITE
            </div>
          </div>
          <h1 className="text-2xl md:text-4xl xl:text-5xl font-black leading-tight mb-6 text-center lg:text-left">
            <div className="flex flex-wrap items-baseline gap-x-1 justify-center lg:justify-start">
              {catchCopyLine1.map((word, i) => (
                <span
                  key={i}
                  className={`inline-block ${word.color} ${word.rotate ?? ""} anim-fade-up anim-delay-${(i + 2) * 100}`}
                  style={{ textShadow: word.rotate ? "2px 2px 0px rgba(0,0,0,0.1)" : "none" }}
                >
                  {word.text}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap items-baseline gap-x-1 mt-1 justify-center lg:justify-start">
              {catchCopyLine2.map((word, i) => (
                <span
                  key={i}
                  className={`inline-block ${word.color} ${word.rotate ?? ""} anim-fade-up anim-delay-${(i + 4) * 100}`}
                  style={{ textShadow: word.rotate ? "2px 2px 0px rgba(0,0,0,0.1)" : "none" }}
                >
                  {word.text}
                </span>
              ))}
            </div>
          </h1>

          <p className="text-base md:text-lg text-gray-600 font-bold mb-6 leading-relaxed anim-fade-up anim-delay-400">
            トラックドライバー達が贈る、<br />
            <span className="text-[#FF0F0F] font-black">笑えて</span>、<span className="text-[#0066FF] font-black">学べて</span>、<span className="text-[#00B050] font-black">ためになる</span><br />
            運送業バラエティチャンネル！
          </p>

          <div className="anim-fade-up anim-delay-500">
            <PlaylistSlider />
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start anim-fade-up anim-delay-600">
            <a
              href="https://www.youtube.com/@truckboys"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#FF0F0F] text-white font-black text-lg px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:scale-105 transition-transform border-4 border-black animate-pulse-scale"
              style={{ boxShadow: "4px 4px 0px #000", animationDelay: "1s" }}
            >
              <i className="ri-youtube-fill text-2xl"></i>
              YouTubeチャンネルはこちら！
            </a>
            <a
              href="#entry"
              className="inline-flex items-center justify-center gap-2 bg-[#00B050] text-white font-black text-lg px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:scale-105 transition-transform border-4 border-black"
              style={{ boxShadow: "4px 4px 0px #000" }}
            >
              <i className="ri-mail-send-fill text-xl"></i>
              採用エントリー
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-xs font-black text-gray-400 tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-gray-400 text-lg"></i>
      </div>
    </section>
  );
}
